import UBT from '@/utils/tianqi';

export default {
  install(Vue) {
    Vue.prototype.UBT = UBT;
  },
};
